var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-mask",style:({'position':_vm.position})},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('img',{attrs:{"alt":"Tixgo","src":require("../assets/logo.svg"),"width":"100"}})])
}]

export { render, staticRenderFns }